<div class="row">
  <div class="map-container">
    <div class="col-12" id="map"></div>
  </div>
</div>
